module.exports = __webpack_public_path__ + "media/images/beauty/main_image2-be779b9265541e496d947bcdfc460780.jpg";